<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  async mounted() {
    try {
      await this.$store.dispatch('permissions/fetchRolePermissions');
    } catch (e) {
      console.log('ERROR', e);
    }
  },
  data() {
    return {
      isLoading: false,
    };
  },
};
</script>

<style lang="stylus">
</style>
